import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
}

const getters = {
}

const actions = {
  async deleteAllAttendeeRecords ({ commit }, attendeesIds) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.attendee.deleteAttendeeRecords(attendeesIds))
      this.dispatch('showResultSuccessMessage', 'Deleted')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Attendees\' records weren\'t deleted')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateBlockAttendeeSettings ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.blockAttendeeSettings.updateSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Settings were successfully updated!')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to update settings')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async unblockBlockedAttendee ({ commit }, attendeeId) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.blockAttendeeSettings.unblockAttendee(attendeeId))
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to unblock attendee')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updatePlaceholderValue ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.staticContent.putContent(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Settings were successfully updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to update settings')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateIsInTopStatus ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.attendee.changeIsInTop(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Attendees\' position in list was successfully changed!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to change attendees\' position in list')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/attendeeMutual.js